import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createAddCashdeskModel } from 'features/add-cashdesk';
import { createBlockCashdeskModel } from 'features/block-cashdesk';
import { createDeleteCashdeskModel } from 'features/delete-cashdesk';
import { createDepositCashdeskModel } from 'features/deposit-cashdesk';
import { createEditCashdeskModel } from 'features/edit-cashdesk';
import { createUnblockCashdeskModel } from 'features/unblock-cashdesk';
import { createWithdrawCashdeskModel } from 'features/withdraw-cashdesk';
import { accountTreeModel } from 'entities/account';
import { createCashdeskRegistryModel } from 'entities/cashdesk';

const editCashdeskModel = createEditCashdeskModel();

const addCashdeskModel = createAddCashdeskModel();

const blockCashdeskModel = createBlockCashdeskModel();

const unblockCashdeskModel = createUnblockCashdeskModel();

const deleteCashdeskModel = createDeleteCashdeskModel();

const withdrawCashdeskModel = createWithdrawCashdeskModel();

const depositCashdeskModel = createDepositCashdeskModel();

export const cashdeskRegistryModel = createCashdeskRegistryModel({
	currencies: accountTreeModel.$currencies,
	onUpdate: [
		addCashdeskModel.addCashdeskMutation.finished.success,
		depositCashdeskModel.depositCashdeskMutation.finished.success,
		withdrawCashdeskModel.withdrawCashdeskMutation.finished.success,
		editCashdeskModel.editCashdeskMutation.finished.success,
		blockCashdeskModel.mutation.finished.success,
		unblockCashdeskModel.mutation.finished.success,
	],
	onDelete: [deleteCashdeskModel.mutation.finished.success],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: cashdeskRegistryModel.model.filters.accountIds.setValue,
});

chain(cashdeskRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const cashdesksPageModel = {
	addCashdeskModel,
	cashdeskRegistryModel,
	blockCashdeskModel,
	unblockCashdeskModel,
	deleteCashdeskModel,
	editCashdeskModel,
	withdrawCashdeskModel,
	depositCashdeskModel,
};
